export const formConfig = {
  CREATE_NETWORK: {
    fields: {
      name: {
        validators: ['required'],
      },
      standardImageBytes: {
        validators: ['required'],
      },
      widescreenImageBytes: {
        validators: ['required'],
      },
    },
  },
  UPDATE_NETWORK: {
    fields: {
      name: {
        validators: ['required'],
      },
      standardImageBytes: {
        validators: [
          (value, {standardImageURL: standardImageUrl}) =>
            !value || (Array.isArray(value) && !value.length) || value === ''
              ? !standardImageUrl || standardImageUrl === ''
                ? 'This field cannot be empty'
                : undefined
              : undefined,
        ],
      },
      widescreenImageBytes: {
        validators: [
          (value, {widescreenImageURL: widescreenImageUrl}) =>
            !value || (Array.isArray(value) && !value.length) || value === ''
              ? !widescreenImageUrl || widescreenImageUrl === ''
                ? 'This field cannot be empty'
                : undefined
              : undefined,
        ],
      },
    },
  },
  CREATE_FOLDER: {
    fields: {
      name: {
        validators: ['required'],
      },
      widescreenImageBytes: {
        validators: ['required'],
      },
      dataPackages: {
        validators: ['required'],
      },
    },
  },
  UPDATE_FOLDER: {
    fields: {
      widescreenImageBytes: {
        validators: [
          (value, {widescreenImageURL: widescreenImageUrl}) =>
            !value || (Array.isArray(value) && !value.length) || value === ''
              ? !widescreenImageUrl || widescreenImageUrl === ''
                ? 'This field cannot be empty'
                : undefined
              : undefined,
        ],
      },
      dataPackages: {
        validators: ['required'],
      },
    },
  },
  CREATE_STOREFRONT: {
    fields: {
      name: {
        validators: ['required'],
      },
    },
  },
  UPDATE_STOREFRONT: {
    fields: {
      name: {
        validators: ['required'],
      },
    },
  },
};
